<template>
  <div class="box-content">
    <img src="../../image/prize/prizeRule.jpg" alt srcset class="img" />
    <div class="btnlist">
      <van-button class="goPrize" @click="goCustomer">咨询客服</van-button>
      <van-button class="goPrize" @click="goPrize">返回大转盘抽奖</van-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goPrize() {
      this.$router.go(-1)
    },
    goCustomer() {
      this.$router.replace({
        name: "Customer"
      });
    }
  }
};
</script>

<style scoped>
.box-content {
  max-width: 750px;
  margin: 0 auto;
  position: relative;
}

.img {
  width: 100%;
  height: 100%;
  display: block;
}

.btnlist {
  position: absolute;
  bottom: 30%;
  left: 0;
  right: 0;
  opacity: 0.8;
  margin: 10px auto;
  width: 80%;
}

.goPrize {
  margin: 2% 0;
  width: 100%;
  /* height: calc(100vh / 17); */
  box-shadow: 0 5px 10px -5px rgb(0, 0, 0);
  color: #fff !important;
  letter-spacing: 3px;
  border-radius: 30px;
}
.van-button--default {
  background-image: linear-gradient(to bottom right, #f7804d, #f14532);
  font-size: 18px;
  font-weight: 600;
  border: none;
}
</style>